import { apiFetch } from './apiClient.js';

export type VariableSource =
  | 'dialog360' | 'meta' | 'webchat' | 'zengine' | 'crm-lookup' | 'webhook-custom' | 'other';
export type VariableTarget = 'five9' | 'salesforce' | 'custom' | 'none';
export type VariableType = 'string' | 'number' | 'boolean' | 'enum' | 'array' | 'object';
export type VariableStatus = 'active' | 'error' | 'unused';

export interface VariableMapping {
  id: string;
  tenantId: string;
  source: VariableSource;
  sourceVariable: string;
  zengineVariable: string;
  targetSystem: VariableTarget;
  targetVariable?: string;
  type: VariableType;
  status: VariableStatus;
  description?: string;
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface VariableMappingCreate {
  source: VariableSource;
  sourceVariable: string;
  zengineVariable: string;
  targetSystem: VariableTarget;
  targetVariable?: string;
  type: VariableType;
  status?: VariableStatus;
  description?: string;
}

export type VariableMappingPatch = Partial<VariableMappingCreate>;

export async function listVariables(
  tenantId: string,
  opts: { includeArchived?: boolean } = {},
): Promise<VariableMapping[]> {
  const qs = opts.includeArchived ? '?includeArchived=true' : '';
  const res = await apiFetch<{ items: VariableMapping[] }>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/variables${qs}`,
  );
  return res.items;
}

export async function createVariable(tenantId: string, body: VariableMappingCreate): Promise<VariableMapping> {
  return apiFetch<VariableMapping>(`/v1/tenants/${encodeURIComponent(tenantId)}/variables`, {
    method: 'POST', body,
  });
}

export async function updateVariable(
  tenantId: string, id: string, patch: VariableMappingPatch, ifMatchVersion: number,
): Promise<VariableMapping> {
  return apiFetch<VariableMapping>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/variables/${encodeURIComponent(id)}`,
    { method: 'PATCH', body: patch, headers: { 'If-Match': String(ifMatchVersion) } },
  );
}

export async function archiveVariable(tenantId: string, id: string): Promise<VariableMapping> {
  return apiFetch<VariableMapping>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/variables/${encodeURIComponent(id)}/archive`,
    { method: 'POST' },
  );
}
